export type OrderPaymentInfoRow = {
  payment_id?: string;
  method?: string;
  payment_date?: string | Date | null;
  amount_paid?: number | string;
  total_amount?: number | string;
  paid_by?: { name?: string; email?: string };
};

export function getOrderPaymentInfoList(order: unknown): OrderPaymentInfoRow[] {
  return Array.isArray((order as { payment_info?: unknown })?.payment_info)
    ? (((order as { payment_info?: OrderPaymentInfoRow[] }).payment_info ?? []) as OrderPaymentInfoRow[])
    : [];
}

/** Latest payment row by `payment_date` (matches InvoiceDocument). */
export function pickLatestOrderPaymentInfo(order: unknown): OrderPaymentInfoRow | null {
  const arr = getOrderPaymentInfoList(order);
  if (!arr.length) return null;
  return arr
    .slice()
    .sort(
      (a, b) =>
        new Date(b?.payment_date || 0).getTime() - new Date(a?.payment_date || 0).getTime()
    )[0];
}

export function sumOrderPaymentInfoAmountPaid(order: unknown): number {
  return getOrderPaymentInfoList(order).reduce(
    (acc, pay) => acc + Number(pay?.amount_paid || 0),
    0
  );
}

/** Paid By name: show "-" when this payment row has amount_paid of 0. */
export function displayPaymentPaidByName(payment?: {
  amount_paid?: number | string | null;
  paid_by?: { name?: string | null } | null;
} | null): string {
  const paid = Number(payment?.amount_paid ?? 0);
  if (!Number.isFinite(paid) || paid <= 0) return "-";
  const name = String(payment?.paid_by?.name ?? "").trim();
  return name || "-";
}
